
export enum AnalyticsEventActions
{
    TODO = 'todo',

    GA_CONVERSION = 'conversion',

    // web_basics
    // ---------------------------------------------------
    WEB_PAGE_LOADED = 'web__page_loaded',

    WEB_VIDEO_PLAY_STARTED = 'web__video_play_started',
    WEB_VIDEO_PLAY_STOPPED = 'web__video_play_stopped',
    WEB_PAGE_SCROLL_DOWN = 'web__page_scroll_down',
    WEB_PAGE_SCROLL_TO_END = 'web__page_scroll_to_end',

    // web_docs
    // ---------------------------------------------------
    DOCS_PAGE_LOADED = 'docs__page_loaded',
    DOCS_VIDEO_PLAYED = 'docs__video_played',
    DOCS_SAMPLE_DESIGN_LANDED = 'docs__sample_design_landed',
    DOCS_SAMPLE_DESIGN_LOADED = 'docs__sample_design_loaded',
    DOCS_TRY_IT_NOW_CLICKED = 'docs__try_it_now_clicked',

    // user_enter
    // ---------------------------------------------------
    WEB_SIGNUP_GOOGLE_DIALOG_OPENED = 'web__signup_google_dialog_opened',
    WEB_SIGNUP_GOOGLE_DIALOG_CONFIRMED = 'web__signup_google_dialog_confirmed',
    WSP_SIGNUP_FIRST_PAGE_LANDED = 'wsp__signup_first_page_landed',
    WSP_SIGNUP_FIRST_PAGE_LOADED = 'wsp__signup_first_page_loaded',
    WSP_LOGIN_FIRST_PAGE_LANDED = 'wsp__login_first_page_landed',
    WSP_LOGIN_FIRST_PAGE_LOADED = 'wsp__login_first_page_loaded',

    // user_invite
    // ---------------------------------------------------
    WSP_INVITE_SENT = 'wsp__invite_sent',
    WSP_INVITE_NEW_USER_LOADED = 'wsp__invite_new_user_loaded',
    WSP_INVITE_NEW_USER_CONFIRMED_ORG = 'wsp__invite_new_user_confirmed_org',
    WSP_INVITE_NEW_USER_FIRST_PAGE_LANDED = 'wsp__invite_new_user_first_page_landed',
    WSP_INVITE_NEW_USER_FIRST_PAGE_LOADED = 'wsp__invite_new_user_first_page_loaded',

    // wsp_usage
    // ---------------------------------------------------
    WSP_ORG_CREATED = 'wsp__org_created',
    WSP_PROFILE_NAME_EDITED = 'wsp__profile_name_edited',
    WSP_PROFILE_CHANGED_PASSWORD = 'wsp__profile_changed_password',

    WSP_PAGE_LANDED = 'wsp__page_landed',
    WSP_PAGE_LOADED = 'wsp__page_loaded',

    WSP_DESIGN_CREATED = 'wsp__design_created',
    WSP_SPACE_CREATED = 'wsp__space_created',
    WSP_ORG_SWITCHED = 'wsp__org_switched',
    WSP_DESIGN_RENAMED = 'wsp__design_renamed',
    WSP_DESIGN_DUPLICATED = 'wsp__design_duplicated',
    WSP_DESIGN_MOVED = 'wsp__design_moved',

    // wsp_design_usage
    // ---------------------------------------------------
    WSP_DESIGN_OPEN_CLICKED = 'wsp__design_open_clicked',
    WSP_DESIGN_PUBLISHED = 'wsp__design_published',

    // wsp_designer_usage
    // ---------------------------------------------------
    WSP_DESIGNER_LANDED = 'wsp__designer_landed',
    WSP_DESIGNER_FIRST_RENDER = 'wsp__designer_first_render',
    WSP_DESIGNER_LOADED = 'wsp__designer_loaded',
    WSP_DESIGNER_ACTIVE = 'wsp__designer_active',
}
